module.exports = __webpack_public_path__ + "img/pillar.59a7685b.png";